/* eslint-disable @typescript-eslint/no-unused-vars */
import { IMainSectionsAreaData } from "src/typings/section-area-data";
import { RendererBase } from "../../shared/renderer-base";

export class MainSectionsAreaRenderer extends RendererBase<IMainSectionsAreaData> {
    
    protected override createNewInternal(): HTMLElement {
        let main = document.querySelector("main") as HTMLElement;
        if (main) {
            return main;
        }
        
        main = document.createElement("main");

        main.setAttribute("data-section-area", "");
        main.id = "main";

        return main;
    }

    protected override renderInternal(element: HTMLElement, data: IMainSectionsAreaData): HTMLElement {
        // nothing
        return element;
    }

    protected cleanupInternal(element: HTMLElement): void {
        // nothing
    }

    protected override getContentSelectorsInternal(element: HTMLElement): string[] {
        return [];
    }

}
